import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MoverPortal from './MoverPortal.jsx';

const MoverPortalWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoginRoute = location.pathname.endsWith('/login');

  useEffect(() => {
    if (isLoginRoute) return;
    // Check if user is already logged in as admin
    const token = localStorage.getItem('token');
    const storedUserData = localStorage.getItem('userData');
    
    if (token && storedUserData) {
      try {
        const userData = JSON.parse(storedUserData);
        if (userData.role === 'admin') {
          console.log('Admin already logged in, redirecting to admin portal...');
          navigate('/admin-portal', { replace: true });
          return;
        }
      } catch (error) {
        console.error('Error parsing userData in wrapper:', error);
      }
    }
  }, [navigate, isLoginRoute]);

  return <MoverPortal />;
};

export default MoverPortalWrapper;